// Função addToCart genérica que estava faltando
window.addToCart = function (formId) {
  // Encontra o formulário pelo ID
  const form = document.getElementById(formId);
  if (!form) {
    return;
  }

  // Cria um FormData do formulário
  const formData = new FormData(form);

  // Verificar especificamente o selling_plan
  let sellingPlanValue = formData.get("selling_plan");

  // CORREÇÃO: Se selling_plan não foi capturado, buscar manualmente
  if (!sellingPlanValue) {
    const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
    if (sellingPlanSelect) {
      sellingPlanValue = sellingPlanSelect.value;

      // Adicionar ao FormData se não estiver presente
      if (sellingPlanValue && sellingPlanValue !== "") {
        formData.set("selling_plan", sellingPlanValue);
      }
    }
  }

  // Faz a requisição AJAX para adicionar ao carrinho
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      // Atualiza o carrinho
      if (typeof window.refreshCart === "function") {
        window.refreshCart();
      }

      // Abre o carrinho lateral
      if (typeof window.showCart === "function") {
        window.showCart();
      }
    })
    .catch((error) => {
      // Em caso de erro, tenta abrir o carrinho existente
      if (typeof window.showCart === "function") {
        window.showCart();
      }
    });
};
